import {gql} from "@apollo/client";

import {EnumItem} from "@/lib/queries/common.ts";
import {MonitoringServiceChoices, Service} from "@/lib/types/checks.ts";
import {MonitoringServer} from "@/lib/types/monitoring.ts";

export interface PSReportData {
  result_id?: number;
  data?: JSON;
  data_url?: string;
  monitoring_server?: MonitoringServer;
  data_error?: string;
  share_url?: string;
}

export interface PSReportDataResponse {
  psReportData: PSReportData;
  mspChoices: MonitoringServiceChoices;
  service: Service;
}

export const GQL_PS_REPORT_DATA = gql`
  query PagespeedReport($id: Int!, $resultId: Int) {
    service: findCheck(id: $id) {
      id
      name
    }
    psReportData(id: $id, resultId: $resultId) {
      result_id
      data
      data_url
      monitoring_server {
        id
        group_id
        name
        location
        address_ipv4
        address_ipv6
        hostname
        is_nagios
        is_active
        compute_scale_factor
        country
        is_private
        is_test
      }
      data_error
      share_url
    }
    mspChoices {
      connection_throttling {
        value
        label
      }
      emulated_device {
        value
        label
      }
    }
  }
`;

export interface PSShareURL {
  spShareURL: {
    url?: string;
  };
}

export const GQL_PS_SHARE_URL = gql`
  query PageSpeedShareURL($id: Int!, $resultId: Int) {
    spShareURL(id: $id, resultId: $resultId) {
      url
    }
  }
`;

export interface PSMetric {
  name: string;
  datatype: string;
  unit: string;
  label: string;
  description: string;
}

export interface PSMetricsResponse {
  psMetricHistory: {
    series?: JSON;
    metrics?: PSMetric[];
  };
  metricDefs: {
    choices: EnumItem[];
  };
}

export const GQL_PS_METRICS = gql`
  query PageSpeedMetrics($payload: MetricHistoryPayload!) {
    psMetricHistory(payload: $payload) {
      series
      metrics {
        name
        datatype
        unit
        label
        description
      }
    }
    metricDefs {
      choices {
        value
        label
      }
    }
  }
`;

export enum UptimeGrade {
  A = "A",
  B = "B",
  C = "C",
  D = "D",
  F = "F",
}

export interface PSResult {
  id: number;
  account: number;
  service: number;
  monitoring_server: MonitoringServer;
  slug: string;
  created_at: string;
  performance_score: number;
  best_practices_score: number;
  uptime_grade: UptimeGrade;
}

export interface PSReportHistoryResponse {
  psReportHistory: {
    results?: PSResult[];
    page: number;
    has_prev_page: boolean;
    has_next_page: boolean;
  };
}

export const GQL_PS_REPORT_HISTORY = gql`
  query PageSpeedReportHistory($id: Int!, $page: Int) {
    psReportHistory(id: $id, page: $page) {
      results {
        id
        account
        service
        monitoring_server {
          id
          name
          location
        }
        slug
        created_at
        performance_score
        best_practices_score
        uptime_grade
      }
      page
      has_prev_page
      has_next_page
    }
  }
`;
